export const formatUpdatedAt = (updatedAt) => {
  if (!updatedAt) {
    return '';
  }

  const date = new Date(Date.parse(updatedAt));

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const datePart = date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
  });
  const timePart = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).toLowerCase().replace(/\s(?=am|pm)/, '');

  return `${datePart} ${timePart}`;
};
